const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getIncidentCategories(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/config/incident-categories${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch incident categories');
  }
  
  const data = await response.json();
  return data.categories;
}

export async function createIncidentCategory(orgId, categoryData) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/incident-categories`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(categoryData)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create categories');
    }
    throw new Error('Failed to create category');
  }
  
  const data = await response.json();
  return data.category;
}

export async function updateIncidentCategory(orgId, categoryId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/incident-categories/${categoryId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update categories');
    }
    if (response.status === 404) {
      throw new Error('Category not found');
    }
    throw new Error('Failed to update category');
  }
  
  const data = await response.json();
  return data.category;
}

export async function getCategoryVersions(orgId, categoryId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/config/incident-categories/${categoryId}/versions`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Category not found');
    }
    throw new Error('Failed to fetch category versions');
  }
  
  const data = await response.json();
  return data.versions;
}
